import { BlankEnum, UnitOfMeasure } from '../../schemas';

export const getUnitOfMeasureLabel = (unit: UnitOfMeasure | BlankEnum | string) => {
  switch (unit) {
    case UnitOfMeasure.dlg:
      return 'dl/g';
    case UnitOfMeasure.kgm2:
      return 'kg/m2';
    case UnitOfMeasure.kilogram:
      return 'Kilogram';
    case UnitOfMeasure.percent:
      return '%';
    case UnitOfMeasure['%wm']:
      return '% w.m';
    case UnitOfMeasure.ppm:
      return 'ppm';
    case UnitOfMeasure.text:
      return 'Text';
    case UnitOfMeasure['mg/Kg_wm']:
      return 'mg/Kg w.m.';
    case UnitOfMeasure['g/10min']:
      return 'g/10min';
    case UnitOfMeasure['kg/m3']:
      return 'kg/m3';
    case UnitOfMeasure['g/cm3']:
      return 'g/cm3';
    default:
      return '';
  }
};
